import { GET_PER_FACILITY_SUCCESS } from "../actions/patientAction"


const getPerFacilityReducer = (state = [], { type,  data = [] }) => {
    switch (type) {
      case GET_PER_FACILITY_SUCCESS:
        return data
      default:
        return state
    }
  }
  
  export default getPerFacilityReducer